import { render, staticRenderFns } from "./CHomeClosed.vue?vue&type=template&id=4beb60a4&scoped=true&"
import script from "./CHomeClosed.vue?vue&type=script&lang=js&"
export * from "./CHomeClosed.vue?vue&type=script&lang=js&"
import style0 from "./CHomeClosed.vue?vue&type=style&index=0&id=4beb60a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb60a4",
  null
  
)

export default component.exports